import { IBook } from "../../interface/IBook";

export enum EncryptTypeEnum {
  NORMAL = 0, // bit 0
  FOCK_ENCRYPT = 1, // bit 1
  FONT_ENCRYPT = 2, // bit 10
  FOCK_FONT_ENCRYPT = 3, // bit 11
}

// 请求 query 属性
export interface IChapterListQueryTypes {
  bookId: string;
  pageSize?: number;
  encryptType: EncryptTypeEnum;
}

export interface IChapter {
  chapterId: string;
  chapterIndex: number;
  chapterLevel: number;
  chapterName: string;
  isAuth: 0 | 1;
  isVip: number;
  noArchive: number;
  publishTime: number;
  publishTimeFormat: string;
  userLevel: number;
  chapterImageUrl?: string; // 漫画专属
}

export interface IVolume {
  isVolume: boolean;
  volumeId: number;
  volumeName: string;
}

// 请求 query 属性
export interface IChapterListPageTypes {
  bookInfo: IBook;
  last: boolean;
  curReadChapter: number | string;
  lastChapterItem: IChapter;
  volumeItems: {
    chapterItems: IChapter[];
    volumeId: number;
    volumeName: string;
  }[];
}
